import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top with smooth behavior
    window.scrollTo({
      top: 10,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
} 